/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@vendor/sweetalert/dist/sweetalert.min.js';

import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?c412f122d640a7dd5ac13178';

u.use(UIBootstrap5);

export default u;

// Alertify
alertify.set('notifier', 'position', 'top-center');

u.notify = function (message, type = 'success', options = {}) {
  return alertify.notify(message, type, options.wait || 5, options.callback || null);
};

import './product-cart.js?c412f122d640a7dd5ac13178';
import './favorite.js?c412f122d640a7dd5ac13178';

$('#sidebar__brand-toggle').on('click', e => {
  let $this = $(e.currentTarget);

  $this.toggleClass('sidebar__nav-toggle--active');
  $this.children('.sidebar__angle').toggleClass('sidebar__angle--up');
  $('.sidebar__brand').toggleClass('sidebar__brand--active');

  $this.children('i').toggleClass('fa-angle-down fa-angle-up');
});

$('#sidebar__tool-toggle').on('click', e => {
  let $this = $(e.currentTarget);

  $this.toggleClass('sidebar__nav-toggle--active');
  $this.children('.sidebar__angle').toggleClass('sidebar__angle--up');
  $('.sidebar__tool').toggleClass('sidebar__tool--active');

  $this.children('i').toggleClass('fa-angle-down fa-angle-up');
});

// copy current url
$(document).ready(() => {
  $('.j-copy-link-btn').on('click', () => {
    navigator.clipboard.writeText(window.location.href);

    window.setTimeout(() => {
      u.notify('連結已複製');
    }, 300);
  });
})

u.on('load.share.this', () => {
  const sharethisScript = document.createElement('script');

  sharethisScript.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=65b9aebb8500ea0019fbb24f&product=sop';
  sharethisScript.async = 'async';

  document.head.appendChild(sharethisScript);
});

//search clear
$('.js-search-clear').on('click',() => {
  $('.search-input').val('');
})

// //Menu Switch
const mainMenu = $('#main-menu')[0];
const headerMenu = $('#header-menu');
const header = $('.header');
const logo = $('#header-logo');
const sectionOneOptions = {};

if (mainMenu) {
  const toggle = new IntersectionObserver
  (function (
      entries,
      toggle
    ) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          header.addClass('border-bottom');
          headerMenu.addClass('show');
          logo.addClass('hide');
        } else {
          header.removeClass('border-bottom');
          headerMenu.removeClass('show');
          logo.removeClass('hide');
        }
      });
    },
    sectionOneOptions);

  toggle.observe(mainMenu);
}

// sub-menu
const subLink = $('.j-sub-link');
const subContent = $('.j-sub-content');

subLink.hover((e) => {
  const $this = $(e.currentTarget);
  const target = $this.data('target');

  subLink.removeClass('active');
  subContent.removeClass('active');

  $this.addClass('active');
  $(target).addClass('active');
});

// search bar
const searchIcon = $('.search-icon');
const searchBar = $('.search-bar');
const headerNav = $('.header-nav');
const searchClear = $('.search-clear');

searchIcon.on('click', function () {
  searchBar.toggleClass('active');
  searchClear.toggleClass('active');
  headerNav.toggleClass('disappear');
});

searchClear.on('click', function () {
  searchBar.toggleClass('active');
  searchClear.toggleClass('active');
  headerNav.toggleClass('disappear');
});
